import React from 'react';
import { Alert, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Warn when a stopped test still has pending decision
 */
const DecisionRequiredBanner = ({ report, onOpenMetadata }) => {
  if (!report || report.status !== 'Durduruldu') return null;
  if ((report.decision || 'pending') !== 'pending') return null;

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        onOpenMetadata ? (
          <Button color="inherit" size="small" onClick={onOpenMetadata}>
            Karar Gir
          </Button>
        ) : null
      }
    >
      Bu test durdurulmuş ancak post-test kararı kaydedilmemiş. CRO Story bölümünden{' '}
      <strong>Uygula / Reddet / Tekrar Test</strong> kararını girin.
    </Alert>
  );
};

/** Compact reminder for dashboard topbar area */
export const LifecycleRemindersBanner = ({ reminders }) => {
  if (!reminders) return null;

  const { snapshotDue = [], decisionDue = [] } = reminders;
  if (!snapshotDue.length && !decisionDue.length) return null;

  return (
    <Box sx={{ display: 'grid', gap: 1, mb: 2 }}>
      {snapshotDue.length > 0 && (
        <Alert severity="info">
          {snapshotDue.length} canlı test snapshot güncellemesi bekliyor (
          {reminders.snapshotReminderDays}+ gün).{' '}
          <RouterLink to="/dashboard">Dashboard&apos;da gör →</RouterLink>
        </Alert>
      )}
      {decisionDue.length > 0 && (
        <Alert severity="warning">
          {decisionDue.length} durdurulmuş test karar kaydı bekliyor.
        </Alert>
      )}
    </Box>
  );
};

export default DecisionRequiredBanner;
